export default "__VITE_ASSET__6TDifjYE__"